import { SortDown, SortUp } from '@wix/wix-ui-icons-common/on-stage';
import React from 'react';
import { SORT } from '../../../../../../../Constants/TableHeader.Constants';
import { TextButton, TextButtonPriority } from '@wix/wix-ui-tpa/cssVars';
import { classes } from '../TableHeader.st.css';
import biService from '../../../../../../BiEvents/BiService';
import { BI_FILE_SHARE_WIDGET_SORT_BY } from '../../../../../../BiEvents/Constants/BiConstants';
import { useAppContext } from '../../../../../../Shared/AppContext';

const NameComponent = ({
  name,
  sortBy,
  orientation,
  handleTitleColumnOnClick,
  disabledTableHeader,
}: any) => {
  const { compId } = useAppContext();
  const className = disabledTableHeader ? classes.disabledHeader : '';
  const suffixIcon: any =
    sortBy === SORT.SORT_BY.NAME &&
    (orientation === SORT.ORIENTATION.DESC ? (
      <SortDown className={className} />
    ) : (
      <SortUp className={className} />
    ));
  return (
    <div
      style={{
        display: 'flex',
        fontSize: '14px',
        alignItems: 'center',
      }}
    >
      <TextButton
        className={classes.tableHeaderColumn}
        suffixIcon={suffixIcon}
        priority={TextButtonPriority.secondary}
        onClick={() => {
          if (!disabledTableHeader) {
            handleTitleColumnOnClick({ sortBy, selectedId: SORT.SORT_BY.NAME });
            biService(
              { button_description: 'name', is_first: false },
              BI_FILE_SHARE_WIDGET_SORT_BY,
              compId,
            );
          }
        }}
        title={name}
      >
        {name}
      </TextButton>
    </div>
  );
};
export default NameComponent;
